import { Component, Inject, Input, OnInit, SimpleChanges, PLATFORM_ID, ViewEncapsulation, HostBinding, AfterViewInit, ViewChildren, ElementRef, QueryList, OnChanges } from '@angular/core';
import { SwipeToBuy, TripProductType, WizumenProductV2, XSellBanner } from '../../../wizumen-models';
import { UpaService, UpaTarget, UpaTrackingData } from 'projects/common/services/upa.service';
import { Device } from 'projects/common/model/Device';
import { isPlatformBrowser } from '@angular/common';
import { IncentiveLabelTracker } from './incentive-label-tracker.enum';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { Link, OfferCardData, OfferCardSubtype } from 'projects/common/components/offers/offer-card-data.model';
import { WizumenService } from 'projects/common/services/wizumen.service';
import { SwipeToBuyService } from 'projects/common/services/swipe-to-buy.service';
import { UtilsService } from '../../../../../services/utils.service';
import { ScreenType } from '@shopping-angular-components/common-library';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { Currency } from 'projects/common/model/landingModel';

declare var window: any;

enum OffersLayoutType {
  FULL_WIDTH = 'full-width',
  TWO_HALF = 'two-half',
  SQUARE_WITH_HALVES = 'square-with-halves'
}

const LAYOUT_CARD_TYPE: Record<OffersLayoutType, OfferCardSubtype | 'mixed'> = {
  [OffersLayoutType.FULL_WIDTH]: OfferCardSubtype.SIMPLIFIED_ROW,
  [OffersLayoutType.TWO_HALF]: OfferCardSubtype.SIMPLIFIED_HALF,
  [OffersLayoutType.SQUARE_WITH_HALVES]: 'mixed'
};

@Component({
  selector: 'incentive-xsell',
  template: `
    <div class="xsell-container" [ngClass]="{'full-height': this.hasNoAssistanceOffer && this.isCouponXSellEnabled}">

      <incentive-xsell-coupon
        [device]="device" [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"
        [xSellBanner]="xSellBanner" [couponActivated]="this.couponActivated"
        (couponActivatedChange)="this.couponActivated = true">
      </incentive-xsell-coupon>

      <div *ngIf="xSellLinks.length > 0 && xSellOffers.length === 0" class="xsell-products-container old">
        <button class="xsell-coupon-button {{xSellLinks.length === 1 ? 'button-row-content' : 'button-column-content'}}" (click)="handleClick(xSellLinks[0])" name="xSellProductLink">
          <i class="eva-3-icon-{{xSellLinks[0].icon_key}} -eva-3-icon-md"></i>
          <em class="incentive-xsell-label">{{xSellLinks[0].title}}</em>
        </button>

        <div *ngIf="xSellLinks.length > 1" class="xsell-products-column">
          <button *ngFor="let link of xSellLinks.slice(1)" class="xsell-coupon-button {{xSellLinks.length === 2 ? 'button-column-content' : 'button-row-content'}}" (click)="handleClick(link)" name="xSellProductLink">
            <i class="eva-3-icon-{{link.icon_key}} -eva-3-icon-md"></i>
            <em class="incentive-xsell-label">{{link.title}}</em>
          </button>
        </div>
      </div>


      <div *ngIf="xSellOffers.length > 0" [class]="'xsell-products-container ' + offersLayout">
        <simplified-offer-card *ngFor="let offer of xSellOffers; let i = index" #xSellCard
          [moduleId]="moduleId" [uniqueId]="uniqueId" [moduleIndex]="moduleIndex" 
          [currency]="currency" [flow]="flow"         [product]="offer.product"
          [data]="offer"        [locale]="locale"     [isMalbec]="isMalbec"
          [positionIndex]="i"   [couponActivated]="couponActivated"
          [lineBreakLimit]="this.offersLayout === OffersLayoutType.FULL_WIDTH ? null : this.smallestLengthWithMaxLines"
          [imageBaseSize]="this.resolveCardDisplay(i) !== 'SIMPLIFIED_SQUARE' ? 88 : 64"
          [cardDisplay]="this.resolveCardDisplay(i)"
          (offerClicked)="handleClick(offer.link)">
        </simplified-offer-card>
      </div>
    </div>
  `,
  styleUrls: ['./incentive-xsell.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IncentiveXsellComponent implements OnInit, OnChanges, AfterViewInit {
  static upaEventType: string = 'view-incentive';
  readonly OffersLayoutType = OffersLayoutType;

  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;
  @Input() locale: string;
  @Input() flow: string;
  @Input() device: Device;
  @Input() myTravelsHref: string;
  @Input() product: WizumenProductV2;
  @Input() xSellBanner?: XSellBanner;

  @Input() dropdownOpened: boolean;
  @Input() hasAllProducts: boolean;

  @Input() hasTripPlanner: boolean = false;
  @HostBinding("class.full-height")
  @Input() hasNoAssistanceOffer: boolean = false;

  @ViewChildren("xSellCard", {read: ElementRef}) xSellCards: QueryList<ElementRef<HTMLElement>>;

  private mobileImageMediaKey: string = "62517618-f5ea-43ed-b4f6-dca92f3305fc";
  private allProductsImageMediaKey: string = "3150a116-1a4c-4cf5-9cf6-9eae9f459f54";
  private missingProductsImageMediaKey: string = "4b660143-83ff-42fa-bad5-a6452be17094";
  assistanceModalData: SwipeToBuy | null = null;
  smallestLengthWithMaxLines: number | null = null;
  viewIncentiveSent = false;

  xSellLinks: Link[];
  xSellOffers: OfferCardData[];
  offersLayout: OffersLayoutType;

  imageMediaKey: string;
  isDesktop: boolean;
  isXSellAlert: boolean;
  isMalbec: boolean;
  isCouponXSellEnabled: boolean;
  couponActivated: boolean;
  currency: Currency;

  constructor(@Inject(PLATFORM_ID) private platformId: string, private upaService: UpaService, private mediaPictureService: MediaPictureService, 
              private wizumenService: WizumenService, private swipeToBuyService: SwipeToBuyService, private utilsService: UtilsService, 
              private landingModelService: LandingModelService) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isXSellAlert = this.wizumenService.containsXSellAlert(this.xSellBanner);
      this.isDesktop = window.innerWidth >= 767 || this.device?.type === ScreenType.DESKTOP;

      if (!this.isDesktop) {
        this.imageMediaKey = this.mobileImageMediaKey;
      }
      else {
        this.imageMediaKey = this.hasAllProducts ? this.allProductsImageMediaKey : this.missingProductsImageMediaKey;
      }
    }

    this.isCouponXSellEnabled = this.landingModelService.getLandingModel().abTests?.ab.includes("couponXSell|enabled_true");
    this.couponActivated = this.utilsService.getCookieValue("pig-coupon-active") === "true";

    this.currency = this.landingModelService.getLandingModel().currency;
    this.isMalbec = this.xSellBanner?.type === TripProductType.XSELL_MALBEC;
    this.xSellLinks = this.xSellBanner?.links || [];
    this.xSellOffers = this.xSellBanner?.offers || [];
    this.offersLayout = this.resolveLayout();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // el trackView solo se tiene que enviar una vez
    if (changes.dropdownOpened.currentValue && !this.viewIncentiveSent && this.xSellBanner?.links) {
      for (const link of this.xSellBanner?.links) {
        if (link.type) this.sendTracker(link.type, IncentiveLabelTracker.SHOW, link.title, link.url);
      }
      this.viewIncentiveSent = true;
    }
  }

  ngAfterViewInit(): void {
    // Cuando hay solo 2 cards en la misma row, si una necesita 2 líneas, la otra también debe tener 2 líneas
    if (this.offersLayout === OffersLayoutType.TWO_HALF) {
      const textElements: Element[] = Array.from(this.xSellCards)
        .map(card => card.nativeElement)
        .map(card => card?.querySelector(".pricebox-description"))
        .filter((text): text is Element => text !== null && text !== undefined);

      const maxTextHeight: number = textElements
        .map(text => this.resolveCardHeight(text))
        .reduce((max, height) => Math.max(max, height), 0);

      if (maxTextHeight && maxTextHeight > 1) {
        this.smallestLengthWithMaxLines = textElements
          .filter(text => this.resolveCardHeight(text) >= maxTextHeight)
          .map(text => text?.textContent?.length ?? 0)
          .reduce((max, length) => Math.min(max, length), Infinity);
      }
    }
  }

  resolveCardHeight(text: Element): number {
    return Math.round(text.clientHeight / parseFloat(window.getComputedStyle(text).lineHeight));
  }

  handleClick(link: Link): void {
    if (link.type) this.sendTracker(link.type, IncentiveLabelTracker.OPEN, link.title, link.url);
    
    if (this.isCouponXSellEnabled) {
      this.utilsService.setCookieValue("pig-coupon-active", "true");
      this.couponActivated = true;
      if (this.xSellOffers.length === 0) window.open(link.url, '_blank');
    } else {
      window.open(link.url, '_blank');
    }
    
    // TODO: Revisar si se sigue mandando este link acá, o si quedó solo en el wizumenTravelAssistance
    if (link.type === "XSELL_INSURANCE") this.fetchAssistanceModal();
  }

  private sendTracker(label: string, trackerType: IncentiveLabelTracker, linkText: string, url: string): void {
    const upaTrackingData: UpaTrackingData = {
      label: `${label}-${trackerType}-${linkText}-WIZUMEN_NEW`,
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      target: UpaTarget.WIZUMEN_ITERATIONS_V2,
      href: url,
    }

    if (trackerType === IncentiveLabelTracker.SHOW) {
      this.upaService.trackView(upaTrackingData, IncentiveXsellComponent.upaEventType)

    } else if (trackerType === IncentiveLabelTracker.OPEN) {
      this.upaService.trackClickTopic(upaTrackingData);
    }
  }

  public getMediaSrc(): string {
    return this.mediaPictureService.getMediaUrl(this.imageMediaKey, this.hasAllProducts ? "220x128" : "153x134") || "";
  }

  async fetchAssistanceModal() {

    if (this.assistanceModalData) {
      this.openAssistanceModal(this.assistanceModalData);
      return;
    }

    const upaData = window.upaData;
    const webview = this.landingModelService.getLandingModel().webview;
    const domain = webview ? this.extractDomain(window.location.host) : upaData.dn;

    const params = {
      locale: this.locale,
      channel: upaData.ch,
      domain: domain,
      trackerId: upaData.userid,
      socialId: upaData.despegarid,
      webview: webview.toString(),
      openedOnDemand: "true",
    };

    try {
      const assistance: SwipeToBuy = await this.swipeToBuyService.getAssistanceModal(params);

      if (assistance && Object.keys(assistance).length === 0) {
        return;
      }

      this.assistanceModalData = assistance;
      this.openAssistanceModal(assistance);
    } catch (error) {
      console.error('Error fetching assistance modal', error);
    }

  }

  openAssistanceModal(assistance: SwipeToBuy) {
    const openedFromCTA = true;
    this.swipeToBuyService.openModal({
      ...(assistance?.upa_data || {}),
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      uniqueId: this.uniqueId,
      flow: this.flow
    }, assistance, openedFromCTA);
  }

  private resolveLayout(): OffersLayoutType {
    const fullWidthCards = !this.isDesktop
                        ||  this.xSellOffers.length === 1 
                        || (this.xSellOffers.length === 2 && this.hasNoAssistanceOffer) 
                        || (this.xSellOffers.length === 3 && this.hasNoAssistanceOffer && this.hasTripPlanner);

    if (fullWidthCards) return OffersLayoutType.FULL_WIDTH;
    return this.xSellOffers.length === 2 ? OffersLayoutType.TWO_HALF : OffersLayoutType.SQUARE_WITH_HALVES;
  }

  resolveCardDisplay(index: number): OfferCardSubtype {
    const cardType = LAYOUT_CARD_TYPE[this.offersLayout];
    if (cardType === 'mixed') {
      return index === 0 ? OfferCardSubtype.SIMPLIFIED_SQUARE : OfferCardSubtype.SIMPLIFIED_HALF;
    }
    return cardType;
  }

  extractDomain(url: string): string | null {
    const regex = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?([^:\/?\n]+)(?::\d+)?/;
    const match = url.match(regex);
    return match ? match[1] : '';
  }
}
